import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

/**
 * Mobile-only sticky bottom bar with a big "Get started free" CTA.
 * Renders only when:
 *  - user is not logged in
 *  - current route isn't /login, /signup or /kyc (already action-focused)
 *  - app isn't running standalone (PWA installed)
 */
export default function MobileGetStartedBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (user) return null;
  const hideOn = ["/login", "/signup", "/kyc", "/forgot-password", "/reset-password", "/verify"];
  if (hideOn.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      data-testid="mobile-get-started-bar"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-orange-200 bg-white/95 backdrop-blur-xl p-3 pb-[max(env(safe-area-inset-bottom),0.75rem)] shadow-[0_-8px_24px_-8px_rgba(154,52,18,0.15)]"
    >
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="font-display font-black text-sm leading-tight text-slate-900">
            Book your bed from ₹250
          </div>
          <div className="text-[11px] text-slate-500 leading-tight">Sign up in 30 seconds · Aadhaar verified</div>
        </div>
        <Link to="/signup" className="flex-shrink-0">
          <button
            data-testid="mobile-get-started-btn"
            className="h-11 px-5 rounded-full bg-orange-800 hover:bg-orange-900 active:scale-95 transition-transform text-white font-semibold text-sm flex items-center gap-1.5 shadow-md shadow-orange-800/30"
          >
            Get started <ArrowRight size={15} />
          </button>
        </Link>
      </div>
    </div>
  );
}
